var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.999,
    viewBox: "0 0 14 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_icon",
    "data-name": "close icon",
    d: "M12.227,10.994l5.509-5.5a.878.878,0,0,0-1.242-1.242l-5.5,5.509-5.5-5.509A.878.878,0,0,0,4.253,5.495l5.509,5.5-5.509,5.5a.878.878,0,1,0,1.242,1.242l5.5-5.509,5.5,5.509a.878.878,0,1,0,1.242-1.242Z",
    transform: "translate(-3.994 -3.996)",
    fill: "#474b4f",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.0f34c97f0aa1b67a83e47f0ab78f6e1c.svg";
export { ForwardRef as ReactComponent };